(() => {
  const formatEuro = (cents) =>
    new Intl.NumberFormat('pt-PT', {
      style: 'currency',
      currency: 'EUR',
    }).format(cents / 100);

  const initMobileStickyCart = () => {
    document.querySelectorAll('[data-mobile-sticky-cart]').forEach((stickyCart) => {
      if (stickyCart.dataset.initialized === 'true') return;

      const form = document.getElementById(stickyCart.dataset.productFormId);
      const primaryButton = form?.querySelector('[type="submit"][name="add"]');
      const stickyButton = stickyCart.querySelector('[data-mobile-sticky-submit]');
      const priceElement = stickyCart.querySelector('[data-mobile-sticky-price]');
      if (!form || !primaryButton || !stickyButton || !priceElement) return;

      stickyCart.dataset.initialized = 'true';

      const updatePrice = () => {
        const basePrice = Number(stickyCart.dataset.basePrice) || 0;
        const addonCount = typeof form.getAddonCount === 'function' ? form.getAddonCount() : 0;
        const personalizationSelected =
          typeof form.hasPersonalization === 'function' && form.hasPersonalization();
        const personalizationPrice =
          typeof form.getPersonalizationPrice === 'function' ? form.getPersonalizationPrice() : 5;
        const extrasCents = (addonCount * 200) + (personalizationSelected ? personalizationPrice * 100 : 0);
        priceElement.textContent = formatEuro(basePrice + extrasCents);
      };

      const updateVisibility = () => {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const hasPassedPrimaryButton = primaryButton.getBoundingClientRect().bottom < 0;
        const visible = isMobile && hasPassedPrimaryButton;
        stickyCart.classList.toggle('is-visible', visible);
        stickyCart.setAttribute('aria-hidden', visible ? 'false' : 'true');
      };

      const syncButtonState = () => {
        stickyButton.disabled = primaryButton.disabled || primaryButton.getAttribute('aria-disabled') === 'true';
      };

      stickyButton.addEventListener('click', () => {
        if (primaryButton.disabled || primaryButton.getAttribute('aria-disabled') === 'true') {
          primaryButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        form.requestSubmit(primaryButton);
      });

      form.addEventListener('change', () => {
        window.requestAnimationFrame(() => {
          updatePrice();
          syncButtonState();
        });
      });

      const buttonObserver = new MutationObserver(syncButtonState);
      buttonObserver.observe(primaryButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled'],
      });

      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility, { passive: true });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data?.sectionId !== stickyCart.closest('product-info')?.dataset.section) return;
          if (event.data?.variant?.price != null) {
            stickyCart.dataset.basePrice = event.data.variant.price.toString();
          }
          updatePrice();
          syncButtonState();
        });
      }

      updatePrice();
      syncButtonState();
      updateVisibility();
    });
  };

  document.addEventListener('DOMContentLoaded', initMobileStickyCart);
  document.addEventListener('shopify:section:load', initMobileStickyCart);
})();
